import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { areaForPath, setSentryArea, setSentryRole } from "@/lib/sentry";
import { usePortalRole } from "@/hooks/usePortalRole";

/**
 * Keeps Sentry's `area` and `role` tags in sync with the current route and
 * authenticated role. Privacy-safe: only the coarse area (public/portal/admin/…)
 * and the role string are sent — never user IDs, emails, or names.
 */
export function useSentryContext() {
  const { pathname } = useLocation();
  const { role } = usePortalRole();

  useEffect(() => {
    setSentryArea(areaForPath(pathname));
  }, [pathname]);

  useEffect(() => {
    setSentryRole(role ?? null);
  }, [role]);
}
